export default __webpack_public_path__ + "static/media/self.b418722a.svg";